// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"296":"f850b9ae","334":"d43c6bc3","410":"c3bde620","424":"6ff624be","453":"0abb466a","462":"d68cc1b1","526":"26d44d6f","708":"cd2c3ebb","752":"ef550479"}[chunkId] + ".chunk.js";
};